import AttachmentField, { isContactCardAttachment } from './AttachmentField';

export { VCARD_FILENAME } from 'src/constants/messages';
export { isContactCardAttachment };
export default AttachmentField;
